import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Resize from './Resize';

var Scroller = /*#__PURE__*/function (_React$Component) {
  _inherits(Scroller, _React$Component);

  var _super = _createSuper(Scroller);

  // 有外部引用使用
  function Scroller(props) {
    var _this;

    _classCallCheck(this, Scroller);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_refWrapperEl", void 0);

    _defineProperty(_assertThisInitialized(_this), "_refContentEl", void 0);

    _defineProperty(_assertThisInitialized(_this), "_isMouseDown", void 0);

    _defineProperty(_assertThisInitialized(_this), "_isMouseWheelScrolling", void 0);

    _defineProperty(_assertThisInitialized(_this), "_containerSize", void 0);

    _defineProperty(_assertThisInitialized(_this), "_contentSize", void 0);

    _defineProperty(_assertThisInitialized(_this), "_position", void 0);

    _defineProperty(_assertThisInitialized(_this), "_maxPosition", void 0);

    _defineProperty(_assertThisInitialized(_this), "_minPosition", void 0);

    _defineProperty(_assertThisInitialized(_this), "_wheelScrollTimer", void 0);

    _defineProperty(_assertThisInitialized(_this), "_stopScrollTimer", void 0);

    _defineProperty(_assertThisInitialized(_this), "_isScrolling", void 0);

    _defineProperty(_assertThisInitialized(_this), "_resizeWrapperStyle", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onScroll", () => {
      var isUserScrolling = _this._isMouseWheelScrolling || _this._isMouseDown;

      var lastPosition = _this.getPosition();
      /**
       * 这里不使用 event.target.scrollTop
       * 原因：滚动事件未必发生在列表上，可能是其他元素（event.target）触发然后本组件捕获到了
       */


      _this._position = _this._calcScrollPosition();
      var forward = {
        x: _this._position.x > lastPosition.x,
        y: _this._position.y > lastPosition.y
      };

      _this._updateScrollBar();

      if (_this.props.onScroll) {
        _this.props.onScroll(_this._position, {
          forward,
          isUserScrolling,
          isMouseDown: _this._isMouseDown
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_onWheel", () => {
      _this._isMouseWheelScrolling = true;

      if (_this._wheelScrollTimer) {
        clearTimeout(_this._wheelScrollTimer);
      }

      _this._wheelScrollTimer = setTimeout(() => {
        _this._isMouseWheelScrolling = false;
      }, 300);
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseDown", () => {
      _this._isMouseDown = true;
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseUp", () => {
      _this._isMouseDown = false;
    });

    _defineProperty(_assertThisInitialized(_this), "_onContainerResize", rect => {
      if (_this.props.enableResizeObserverContentRect) {
        var {
          width,
          height
        } = rect;
        _this._containerSize = {
          x: width,
          y: height
        };
      } else {
        _this._containerSize = null;
      } // set null for invalid


      _this._maxPosition = null;

      if (_this.props.onContainerResize) {
        _this.props.onContainerResize(_assertThisInitialized(_this));
      }
    });

    _this._isMouseWheelScrolling = false;
    _this._resizeWrapperStyle = {
      height: '100%'
    };
    return _this;
  }

  _createClass(Scroller, [{
    key: "scrollTo",
    value: function scrollTo(_ref) {
      var {
        x = 0,
        y = 0
      } = _ref;

      if (this.props.lock) {
        return;
      }

      this._refWrapperEl.scrollLeft = x;
      this._refWrapperEl.scrollTop = y;
    }
  }, {
    key: "isNearBottom",
    value: function isNearBottom() {
      var threshold = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (!this._refWrapperEl) {
        return false;
      }

      return this._refWrapperEl.scrollHeight - this._refWrapperEl.scrollTop - this._refWrapperEl.clientHeight <= threshold;
    }
  }, {
    key: "getContainerSize",
    value: function getContainerSize() {
      if (!this._containerSize) {
        this._containerSize = this._calcContainerSize();
      }

      return this._containerSize;
    }
  }, {
    key: "getContentSize",
    value: function getContentSize() {
      if (!this._contentSize) {
        this._contentSize = this._calcContentSize();
      }

      return this._contentSize;
    }
  }, {
    key: "getPosition",
    value: function getPosition() {
      if (!this._position) {
        this._position = this._calcScrollPosition();
      }

      return this._position;
    }
  }, {
    key: "getMaxPosition",
    value: function getMaxPosition() {
      var wrapperEl = this._refWrapperEl;
      this._maxPosition = {
        x: wrapperEl.scrollWidth - wrapperEl.clientWidth,
        y: wrapperEl.scrollHeight - wrapperEl.clientHeight
      };
      return this._maxPosition;
    }
  }, {
    key: "getMinPosition",
    value: function getMinPosition() {
      if (!this._minPosition) {
        this._minPosition = {
          x: 0,
          y: 0
        };
      }

      return this._minPosition;
    }
  }, {
    key: "_calcContainerSize",
    value: function _calcContainerSize() {
      if (this._refWrapperEl) {
        return {
          x: this._refWrapperEl.clientWidth,
          y: this._refWrapperEl.clientHeight
        };
      }

      return {
        x: 0,
        y: 0
      };
    }
  }, {
    key: "_calcContentSize",
    value: function _calcContentSize() {
      return {
        x: this._refContentEl.offsetWidth,
        y: this._refContentEl.offsetHeight
      };
    }
  }, {
    key: "_calcScrollPosition",
    value: function _calcScrollPosition() {
      return {
        x: this._refWrapperEl.scrollLeft,
        y: this._refWrapperEl.scrollTop
      };
    }
  }, {
    key: "_updateScrollBar",
    value: function _updateScrollBar() {
      if (this._stopScrollTimer) {
        clearTimeout(this._stopScrollTimer);
      }

      var {
        scrollingClassName
      } = this.props;

      if (!this._isScrolling) {
        this._isScrolling = true;

        if (scrollingClassName) {
          this._refWrapperEl.classList.add(scrollingClassName);
        }
      }

      this._stopScrollTimer = setTimeout(() => {
        this._isScrolling = false;

        if (!this._refWrapperEl) {
          return;
        }

        if (this.props.onScrollEnd) {
          this.props.onScrollEnd(this._position);
        }

        if (scrollingClassName) {
          this._refWrapperEl.classList.remove(scrollingClassName);
        }
      }, 300);
    }
  }, {
    key: "render",
    value: function render() {
      var {
        style,
        contentStyle,
        children,
        lock,
        enableResizeObserverContentRect,
        enableSizeNotifyDeferred,
        className = ''
      } = this.props;
      var computedStyle = style;

      if (lock) {
        computedStyle = _objectSpread(_objectSpread({}, style), {}, {
          overflow: 'hidden'
        });
      } else {
        computedStyle = style;
      }

      return /*#__PURE__*/React.createElement(Resize, {
        wrapperStyle: this._resizeWrapperStyle,
        enableResizeObserverContentRect: enableResizeObserverContentRect,
        enableSizeNotifyDeferred: enableSizeNotifyDeferred,
        onResize: this._onContainerResize
      }, /*#__PURE__*/React.createElement("div", {
        className: classNames('scroller', {
          [className]: Boolean(className)
        }),
        key: "scroller",
        style: computedStyle,
        ref: node => {
          this._refWrapperEl = node;
        },
        onWheel: this._onWheel,
        onMouseDown: this._onMouseDown,
        onMouseUp: this._onMouseUp,
        onScroll: this._onScroll
      }, /*#__PURE__*/React.createElement("div", {
        className: "scroller_content",
        key: "scroller_content",
        style: contentStyle,
        ref: node => {
          this._refContentEl = node;
        }
      }, children)));
    }
  }]);

  return Scroller;
}(React.Component);

_defineProperty(Scroller, "defaultProps", void 0);

_defineProperty(Scroller, "propTypes", void 0);

export { Scroller as default };
Scroller.defaultProps = {
  lock: false,
  scrollingClassName: 'scrolling'
};
Scroller.propTypes = {
  style: PropTypes.object,
  contentStyle: PropTypes.object,
  onScroll: PropTypes.func,
  onContainerResize: PropTypes.func,
  onContentResize: PropTypes.func,
  lock: PropTypes.bool
};